import React from 'react';
import Dialog from '../../../shared/components/Dialog/Dialog';
import './QuoteOverlays.scss';

export default function QuoteDialog({ className = '', ...props }) {
  return <Dialog {...props} portal className={`quote-dialog ${className}`.trim()} />;
}
